import {usePapaParse} from "react-papaparse";
import React, {useEffect, useState} from "react";
import {Grid, Box, FormControl, Select, MenuItem} from "@mui/material";

//components
import LineSvg from "../../LineSvg";
import CustomLink from "../../Common/CustomLink";
import ModalTrigger from "../../Common/ModalTrigger";
import Samples from "../Samples";

//maps
import ChapterOneMap from "../../Maps/ChapterOneMap";
import mapJSON from "../../../Data/JSON/ChapterOneMap.json";
import mapCSV from "../../../Data/EUMACP/Overview/EU-MACP-Overview-No-of-samples-per-country-and-food-commodity.csv";
import makeStyles from "@mui/styles/makeStyles";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  menuPaper: {
    maxHeight: "400px",
  },
}));

const FirstRow = () => {
  const [countryData, setCountryData] = useState(undefined);
  const handleCountryClick = (evt) => {
    setCountryData(evt);
    if (evt === undefined) {
      handleReadString();
    } else {
      if (evt.country) {
        setSelectCountry(evt.country);
      }
    }
  };
  const {readString} = usePapaParse();
  const handleReadString = () => {
    readString(mapCSV, {
      complete: (results, file) => {
        const initialData = {country: "All", data: []};
        const foodCommodities = results.data.map((d) => d["Food commodity"]);
        const unique = [...new Set(foodCommodities)];

        unique.forEach((fc) => {
          if (fc) {
            initialData.data.push({
              country: "All",
              "Food commodity": fc,
              Samples: 0,
            });
          }
        });
        results.data.forEach((d) => {
          const found = initialData.data.find(
            (da) => da["Food commodity"] === d["Food commodity"]
          );
          if (found) {
            found["Samples"] += d["Samples"];
          }
        });
        setCountryData(initialData);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  // map related changes 2025.12
  const [data, setData] = useState([]);
  const [max, setMax] = useState(undefined);
  const [selectCounrty, setSelectCountry] = useState("");
  const classes = useStyles();
  const [groupCountries, setGroupCountries] = useState({});
  const [countrySelectStatus, setCountrySelectStatus] = useState({
    selected: false,
    country: undefined,
  });

  const handleReadStringMap = () => {
    readString(mapCSV, {
      complete: (results, file) => {
        mapJSON.features.map((j) => {
          let sum = 0;
          let none = 0;
          results.data
          .filter((d) => d["Country"] === j.properties["NAME"])
          .forEach((f) => {
            sum += f["Samples"];
            none += f["Non-compliant"];
          });
          j.properties = {...j.properties, sum, none};
          return j;
        });
        setData({json: mapJSON, conv: results.data});
        setMax(Math.max(...mapJSON.features.map((f) => f.properties.sum)));
        console.log(results)
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };


  useEffect(() => {
    handleReadString();
    handleReadStringMap();
  }, []);

  useEffect(() => {
    var grouped = _.mapValues(_.groupBy(data.conv, "Country"), (clist) =>
      clist.map((country) => _.omit(country, "Country"))
    );
    setGroupCountries(grouped);
  }, [data]);

  return (
    <Grid
      item
      container
      direction={ {xs: "column", sm: "column", md: "row"} }
      sx={ {marginTop: {xs: "50px", sm: "50px", md: "90px", position: "relative"}} }
      className="one-map-wrapper"
    >
      <Grid item xs display="flex" flexDirection="column" p={ 3 }>
        <Box display="flex" flexDirection="column">
          <div className="lineSvg">
            <LineSvg/>
          </div>
          <span>EU MACP RESULTS</span>
          <h3>Results by reporting country</h3>
          <p className="paragraph">
            The EU-Coordinated Multiannual Control Programme (<ModalTrigger
            style={ {
              color: "#22294D",
              cursor: "pointer",
              borderBottom: "1px dotted",
            } }
            text="EU MACP"
          />) analyses randomly collected samples of 12 food products. The same products are sampled every three years to track trends.
          </p>

          <p className="paragraph">
            In accordance with{ " " }
            <CustomLink
              href="https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX%3A32023R0731"
              text="Regulation (EU) 2023/731"
            />
            ,{ " " }
            <ModalTrigger
              style={ {
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              } }
              text="EU Member States"
            />
            , Iceland and Norway are requested to take a total of 683 samples per commodity.
          </p>
          <p className="paragraph">
            This minimum number was reached for all commodities except for wheat (658 samples, of which 196 samples were of wholemeal flour, as permitted under the Regulation) and for virgin olive oil (487 samples).
          </p>
        </Box>
        <Box sx={ {mt: 1} } display={ {xs: "none", sm: "none", md: "block"} }>
          <p className="titleChart" style={ {fontFamily: "Roboto Condensed, sans-serif", marginBottom: ".5rem", opacity: 0.8} }>
            Select a country to filter the results below
          </p>
          <FormControl sx={ {m: 1, minWidth: 120, backgroundColor: "white",} }>
            <Select MenuProps={ {classes: {paper: classes.menuPaper}} } value={ selectCounrty }
                    onChange={ (e) => {
                      const state = {
                        country: e.target.value,
                        data: data.conv.filter(
                          (d) => d["Country"] === e.target.value
                        ),
                      };

                      if (e.target.value === "") {
                        setSelectCountry("");
                        setCountrySelectStatus({
                          selected: false,
                          country: undefined,
                        });
                        handleCountryClick(undefined);
                      } else {
                        setCountrySelectStatus(() => {
                          setSelectCountry(e.target.value);
                          handleCountryClick(state);
                          return {
                            selected: true,
                            country: e.target.value,
                          };
                        });
                      }


                    } }
                    sx={ [
                      {
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#22294D",
                        },

                        width: "100%",
                      },
                    ] }
                    displayEmpty
            >
              <MenuItem value="">
                All countries
              </MenuItem>
              { groupCountries &&
              Object.keys(groupCountries).sort((a,b) => {
                if (a === "Northern Ireland" || b === "Northern Ireland") {
                  return 1;
                }
                return a < b   ? -1 : 1
              }).map((c, idx) => {
                if (c !== "null" && c !== "undefined") {
                  return (
                    <MenuItem key={ idx } value={ c }>
                      { c }
                    </MenuItem>
                  );
                }
              }) }
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={ {display: {xs: "none", sm: "block", md: "block"}} }
          className="dataBox1"
        >
          <Samples data={ countryData } chunkSize={ 4 }/>
        </Box>
      </Grid>
      <Grid item xs className="one-two" p={ 3 }>
        <ChapterOneMap
          onCountryClick={ handleCountryClick }
          json={ mapJSON }
          csv={ mapCSV }
          data={ countryData }
        />

        <Box
          className="mapTitle"
          sx={ {display: {xs: "none", md: "contents"}, marginTop: "2rem"} }
        >
          <p>No baby food samples are included in this representation.</p>
        </Box>
      </Grid>
      <Grid
        item
        p={ 3 }
        xs
        sx={ {
          display: {xs: "block", sm: "none", md: "none"},
        } }
        className="one-three"
      >
        <Samples p={ 5 } data={ countryData } chunkSize={ 7 }/>
      </Grid>
    </Grid>
  );
};

export default FirstRow;
